module.exports = __webpack_public_path__ + "img/part_r.db80e907.png";